var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CompanyApi } from '@ClientApi/company';
export const SET_ACCOUNTING_CONNECTION = 'SET_ACCOUNTING_CONNECTION';
export const SET_SALESFORCE_CONNECTION = 'SET_SALESFORCE_CONNECTION';
export const SET_SLACK_CONNECTION = 'SET_SLACK_CONNECTION';
export const SET_AMAZON_BUSINESS_CONNECTION = 'SET_AMAZON_BUSINESS_CONNECTION';
export const SET_EMBURSE_CARDS_CONNECTIONS = 'SET_EMBURSE_CARDS_CONNECTIONS';
export const SET_LOADING_EMBURSE_CARDS_CONNECTIONS = 'SET_LOADING_EMBURSE_CARDS_CONNECTIONS';
export class SetAccountingConnection {
    constructor(accountingConnection) {
        this.type = SET_ACCOUNTING_CONNECTION;
        this.payload = accountingConnection;
    }
}
export class SetSalesforceConnection {
    constructor(salesforceConnection) {
        this.salesforceConnection = salesforceConnection;
        this.type = SET_SALESFORCE_CONNECTION;
        this.payload = salesforceConnection;
    }
}
export class SetSlackConnection {
    constructor(slackConnection) {
        this.slackConnection = slackConnection;
        this.type = SET_SLACK_CONNECTION;
        this.payload = slackConnection;
    }
}
export class SetAmazonBusinessConnection {
    constructor(slackConnection) {
        this.slackConnection = slackConnection;
        this.type = SET_AMAZON_BUSINESS_CONNECTION;
        this.payload = slackConnection;
    }
}
export class SetEmburseCardsConnections {
    constructor(emburseCardsConnections) {
        this.emburseCardsConnections = emburseCardsConnections;
        this.type = SET_EMBURSE_CARDS_CONNECTIONS;
        this.payload = emburseCardsConnections;
    }
}
export class SetLoadingEmburseCardsConnections {
    constructor(loadingState) {
        this.loadingState = loadingState;
        this.type = SET_LOADING_EMBURSE_CARDS_CONNECTIONS;
        this.payload = loadingState;
    }
}
export const getEmburseCardsConnections = (companyId) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(new SetLoadingEmburseCardsConnections(true));
    try {
        const connections = yield CompanyApi.getCompanyGatewayConnections(companyId);
        const emburseCardsConnections = connections === null || connections === void 0 ? void 0 : connections.filter((connection) => (connection === null || connection === void 0 ? void 0 : connection.feedBackend) === 'emburse_cards');
        if (emburseCardsConnections.length === 0 || (emburseCardsConnections.length === 1 && emburseCardsConnections[0] === null)) {
            dispatch(new SetEmburseCardsConnections([]));
        }
        else {
            dispatch(new SetEmburseCardsConnections(emburseCardsConnections));
        }
    }
    finally {
        dispatch(new SetLoadingEmburseCardsConnections(false));
    }
});
